<template src="./html/Availability.html"></template>

<script>
	import swal from 'sweetalert2'
	import Create from './../views/Create.vue'
	import Edit from './../views/Edit.vue'

	export default {
		props: ['user', 'isAuth', 'item'],
		components: {
			'create': Create,
			'edit': Edit,
		},
		data () {
			return {
				newData: [],
				data: null,
			}
		},
		created () {
			this.init()
		},
		mounted() {
		},
		methods: {
			open() {
				this.init()
				var modal = $('#'+this.modal.selector)
				modal.modal('show')
			},
			close() {
				var modal = $('#'+this.modal.selector)
				modal.modal('hide')
			},
			init() {
				this.getData()
			},
			reload() {
				this.$emit('reload')
				this.getData()
			},
			getData() {
				this.$http.get('admin/unavailable/profiles/' + this.$route.params.id)
				.then(response => {
					this.data = response.body
				})
			},
			destroy(item) {
				var that = this
				swal.queue([{
					title: that.$t("messages.attention"),
					text: that.$t("messages.item_can_not_be_retrieved"),
					type: "warning",
					showCancelButton: true,
					confirmButtonColor: "#53e69d",
					cancelButtonColor: "#ff7676",
					confirmButtonText: "Si",
					cancelButtonText: "No",
					showLoaderOnConfirm: true,
					preConfirm: true,
					preConfirm: function () {
						return new Promise(function (resolve) {
							that.$http.delete('admin/unavailable/' + item.id)
							.then(response => {
								that.$emit('reload')
								swal(response.body.title, response.body.text, response.body.type)

								let index = that.data.indexOf(item)
								that.data.splice(index, 1)
							}).catch(function(response) {
								console.log(response)
							})
						})
					}
				}]).catch(swal.noop)
			},
			addData() {
				var start = moment().format('YYYY-MM-DD')
				var end = moment().add(7, 'days').format('YYYY-MM-DD')
				var data = {
					staff_id: this.item.id,
					start_date: start,
					end_date: end,
					comment: '',
					type: this.types[0],
				}
				this.newData.push(data)
			},
			quitData(data) {
				let index = this.newData.indexOf(data)
				this.newData.splice(index, 1)
			},
		}
	}	
</script>


// WEBPACK FOOTER //
// src/components/projects/availability/layout/Availability.vue